(function () {
  /*
   * Fills the AddToCart / InitiateCheckout gap in the Meta Pixel and
   * TikTok Pixel loaded in theme.liquid (which previously only ever sent
   * PageView / ViewContent). Purchase tracking can't be added here -- this
   * store's checkout is Shopify-hosted with no checkout.liquid access, so
   * that has to go through Shopify's Customer Events (Web Pixels) manager
   * in Admin instead.
   */

  function activeCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  }

  function fireAddToCart(item) {
    if (!item || !item.product_id) return;
    var quantity = item.quantity || 1;
    var unitPrice = (item.price || 0) / 100;
    var lineValue = (item.final_line_price != null ? item.final_line_price : item.line_price != null ? item.line_price : item.price * quantity) / 100;
    var contentId = String(item.product_id);
    var currency = activeCurrency();

    if (window.fbq) {
      fbq('track', 'AddToCart', {
        content_ids: [contentId],
        content_name: item.product_title || item.title,
        content_type: 'product',
        contents: [{ id: contentId, quantity: quantity, item_price: unitPrice }],
        value: lineValue,
        currency: currency,
      });
    }
    if (window.ttq) {
      ttq.track('AddToCart', {
        content_id: contentId,
        content_name: item.product_title || item.title,
        content_type: 'product',
        quantity: quantity,
        price: unitPrice,
        value: lineValue,
        currency: currency,
      });
    }
  }

  // Every add-to-cart path in this theme (main product form, quick add,
  // the bundle "Add to Cart" button, the cart-upgrade swap) posts to
  // /cart/add.js -- intercepting fetch() here catches AddToCart regardless
  // of which component triggered it, instead of wiring each one separately.
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var promise = nativeFetch.apply(this, arguments);
    if (!isCartAdd) return promise;

    promise
      .then(function (response) {
        return response.clone().json();
      })
      .then(function (data) {
        if (!data) return;
        if (Array.isArray(data.items)) {
          data.items.forEach(fireAddToCart);
        } else if (!data.status) {
          // A single-item response (the common case) has no "status" key;
          // an error response does, so this skips failed adds.
          fireAddToCart(data);
        }
      })
      .catch(function () {});

    return promise;
  };

  // Both the cart page and the cart drawer use name="checkout" on their
  // submit button. Fetch the live cart total first and fire before letting
  // the real navigation to /checkout proceed, since a pixel call started
  // during page unload isn't guaranteed to complete.
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[name="checkout"]');
      if (!trigger || trigger.dataset.ssIcSent) return;
      event.preventDefault();

      var proceed = function () {
        trigger.dataset.ssIcSent = 'true';
        if (trigger.form) {
          trigger.form.requestSubmit(trigger);
        } else {
          trigger.click();
        }
      };
      var safety = setTimeout(proceed, 800);

      fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var currency = activeCurrency();
          var value = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) / 100;

          // Meta's `contents` items key the id as "id".
          var fbContents = cart.items.map(function (i) {
            return { id: String(i.product_id), quantity: i.quantity, item_price: (i.price || 0) / 100 };
          });
          // TikTok's `contents` items key it as "content_id" -- same data,
          // different field name, so these can't share one array.
          var ttContents = cart.items.map(function (i) {
            return {
              content_id: String(i.product_id),
              content_name: i.product_title,
              content_type: 'product',
              quantity: i.quantity,
              price: (i.price || 0) / 100,
            };
          });

          if (window.fbq) {
            fbq('track', 'InitiateCheckout', {
              content_ids: fbContents.map(function (c) { return c.id; }),
              contents: fbContents,
              value: value,
              currency: currency,
              num_items: cart.item_count,
            });
          }
          if (window.ttq) {
            ttq.track('InitiateCheckout', { contents: ttContents, value: value, currency: currency });
          }
        })
        .catch(function () {})
        .finally(function () {
          clearTimeout(safety);
          proceed();
        });
    },
    true
  );
})();
